import { Component, Inject, ViewChild, ElementRef, OnInit, QueryList, ViewChildren } from '@angular/core';
import { MatDialogRef, MAT_DIALOG_DATA } from '@angular/material/dialog';
import { DialogBase, ObjectTypeClassInfo, PhotoAngleInfo, T4Image, ImageType } from 't4core';
import { CreateObjectTypeClassDialog } from '../CreateObjectTypeClassDialog/CreateObjectTypeClassDialog';
import { T4TranslationEditorComponent } from '../../../../t4common/components/t4-translation-editor/t4-translation-editor.component';

@Component({
  styleUrls: ['PhotoAngleDialog.css'],
  selector: 'PhotoAngleDialog',
  templateUrl: 'PhotoAngleDialog.html',
})
export class PhotoAngleDialog extends DialogBase implements OnInit {

  public objectTypeClasses: ObjectTypeClassInfo[] = [];
  public photoAngle: PhotoAngleInfo;
  public image: T4Image = new T4Image();
  private base64ImageData: string = "";
  public translationKey: string = '';

  @ViewChild("txtFile") private txtFile: ElementRef;
  @ViewChildren(T4TranslationEditorComponent) translationEditors: QueryList<T4TranslationEditorComponent>;
  constructor(
    public dialogRef: MatDialogRef<CreateObjectTypeClassDialog>,
    @Inject(MAT_DIALOG_DATA) public data: any
  ) {
    super("PhotoAngleDialog");
  }
  public async ngOnInit() {
    this.photoAngle = new PhotoAngleInfo();
    this.photoAngle.TypeClassId = this.data.typeClassId;
    if (this.data.photoAngleData) {
      this.photoAngle.Id = this.data.photoAngleData.Id;
      this.photoAngle.Key = this.data.photoAngleData.Key;
      this.image = await this.Api.get<T4Image>("Data/GetImage", { type: ImageType.PhotoAngle, entityId: this.data.photoAngleData.Id });
      
    }

  }

  public async getObjectClassesByPhotoAngle() {
    var token = this.UI.beginLoading("T4.Settings.PhotoAngleDialog.msgLoading", "Loading Object Type Class", null);
    this.objectTypeClasses = await this.Api.get<ObjectTypeClassInfo[]>("Settings/GetObjectTypeClassesByPhotoAngleId", { photoAngleId: this.data.photoAngleData.Id });
    this.UI.loaderCompleted(token);
  }

  public async save() {
    
    this.photoAngle.Name = `T4.Data.PhotoAngle.${this.data.typeClassId}.${this.photoAngle.Key}.Name`;
    this.photoAngle.Description = `T4.Data.PhotoAngle.${this.data.typeClassId}.${this.photoAngle.Key}.Description`;

    var token = this.UI.beginLoading("T4.Settings.PhotoAngleDialog.msgCreatingPA", "Creating new photo angle", null);
    var angleId = await this.Api.post<any>("Rental/CreatePhotoAngle", this.photoAngle);

    //Save the translation editors.
    await this.translationEditors.forEach(tb => tb.saveTranslations());

    //Save image based on angleId
    var img = await this.Api.post<T4Image>("Data/SetImage", "\"" + this.base64ImageData + "\"", { type: ImageType.PhotoAngle, entityId: angleId });
    this.image = await this.Api.get<T4Image>("Data/GetImage", { type: ImageType.PhotoAngle, entityId: angleId });
    var updatedPhotoAngle = new PhotoAngleInfo();
    updatedPhotoAngle.Id = angleId;
    updatedPhotoAngle.ImageUri = this.image.Uri;
    var updateResult = await this.Api.post<any>("Rental/UpdatePhotoAngle", updatedPhotoAngle);
    this.dialogRef.close();
    this.UI.loaderCompleted(token);
  }
  public beginUpload() {
    this.txtFile.nativeElement.click();
  }
  public upload(files: FileList) {
    let me = this;
    let file = files[0];
    let reader = new FileReader();
    reader.readAsDataURL(file);
  
    reader.onload = async function () {
      const image = new Image();
      image.src = reader.result.toString();
      me.base64ImageData = reader.result.toString();
      // Strip the base64 prefix if needed
      const formattedBase64ImageData = me.base64ImageData.replace(/^data:image\/(png|jpg|jpeg);base64,/, "");
      me.image.Data = formattedBase64ImageData;
    };
    reader.onerror = function (error) {
      console.log('Error: ', error);
    };
  }
  onKeyBlur(): void {
    const keyValue = this.photoAngle.Key;
    if (keyValue) {
      this.translationKey = keyValue;
    } else {
      this.translationKey = '';
    }
  }
}
